const buildHydratableState = (state) => ({
  orderInfo: state.orderInfo,
  storageInfo: state.storageInfo,
  customerInfo: state.customerInfo,
  additionalInfo: state.additionalInfo,
  storageDays: state.storageDays,
  queryPrices: state.queryPrices,
  bookingContext: state.bookingContext,
  paymentIntent: state.paymentIntent
})

export const encodeStateForQuery = (state) => {
  try {
    const json = JSON.stringify(buildHydratableState(state))
    return encodeURIComponent(window.btoa(unescape(encodeURIComponent(json))))
  } catch (error) {
    console.error('Failed to encode state for query', error)
    return ''
  }
}

export const decodeStateFromQuery = (value) => {
  if (!value) {
    return null
  }

  try {
    const decoded = window.atob(decodeURIComponent(value))
    return JSON.parse(decodeURIComponent(escape(decoded)))
  } catch (error) {
    console.error('Failed to decode state from query', error)
    return null
  }
}
